// TODO: Hook up logging somewhere outside of local
// TODO: Hook up page tracking with google analytics
export default class LoggingService {
    static LogErrors(errors: Array<string> | null | undefined, data?: unknown) {
        if (errors) {
            console.error(errors.join(', '), data);
        }
    }

    static LogError(message: string, data?: unknown) {
        console.error(message, data);
    }

    static LogTrace(message: string) {
        console.log(message);
    }
}